import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ConfigService } from './config.service';
import { HttpRetryableService } from './http-retryable.service';

@Injectable({
  providedIn: 'root'
})
export class ForwardingUploadService {
  private readonly baseUrl: string;

  constructor(
    private readonly http: HttpRetryableService,
    config: ConfigService
  ) {
    this.baseUrl = `${config.baseRestURL}forwarding/upload`;
  }

  public uploadForwarderReport(request: {
    document: Blob;
    forwardingRequestId: number;
  }): Observable<unknown> {
    const formData = new FormData();
    formData.append('document', request.document);
    formData.append('forwardingRequestId', String(request.forwardingRequestId));
    return this.http.put(`${this.baseUrl}/forwarder-report`, formData);
  }

  public uploadTtnDocument(request: {
    document: Blob;
    forwardingRequestId: number;
    orderNumber: string;
    vehicleDataId: string;
  }): Observable<unknown> {
    const formData = new FormData();
    formData.append('document', request.document);
    formData.append('forwardingRequestId', String(request.forwardingRequestId));
    formData.append('orderNumber', request.orderNumber);
    formData.append('vehicleDataId', String(request.vehicleDataId));
    return this.http.put(`${this.baseUrl}/consignment-report`, formData);
  }

  public uploadTrnDocument(request: {
    document: Blob;
    forwardingRequestId: number;
    orderNumber: string;
    vehicleDataId: string;
  }): Observable<unknown> {
    const formData = new FormData();
    formData.append('document', request.document);
    formData.append('forwardingRequestId', String(request.forwardingRequestId));
    formData.append('orderNumber', request.orderNumber);
    formData.append('vehicleDataId', String(request.vehicleDataId));
    return this.http.put(`${this.baseUrl}/waybill-report`, formData);
  }
}
